<template>
    <div class="first-loading">
        <div class="spinner-container">
            <van-loading class="spinner-progress" color="black" size="60px"/>
            <!-- <span class="spinner-text">{{$t("tips.loading")}}...</span> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'firstloading'
    }
</script>

<style lang="scss">
.first-loading {
    position: relative;
    .spinner-container{
        position: fixed; 
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
        width: 120px;
        height: 120px;
        background: rgba(0, 0, 0, 0.4);
        padding: 30px 0;
        text-align: center;
        border-radius: 10px;
        .spinner-progress{
            display: inline-block;
            vertical-align: middle;
        }
        // .spinner-text{
        //     margin-left: 8px;
        //     font-size: 14px;
        //     color: #a9a6a6;
        // }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/firstLoading.vue